export default __webpack_public_path__ + "static/media/white-plus.01cffc31.svg";